// Cari Hareket Detayları (Cari Raporu) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'accounts.transactions';

export const accountTransactionsGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Cari hareketleri nasıl incelenir?'),
  intro: t(`${G}.intro`, 'Bu sayfa bir carinin hareketlerini listeler ve carinin güncel bakiyesini gösterir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    toolbar: t(`${G}.regions.toolbar`, 'Loglar / Excel'),
    stats: t(`${G}.regions.stats`, 'Toplamlar'),
    table: t(`${G}.regions.table`, 'Hareket listesi'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. İlk açılışta son 1 ay gösterilir'),
      text: t(`${G}.s1.text`, 'Sayfa açıldığında yalnız son 1 aylık hareketler listelenir. Böylece sayfa daha hızlı açılır ve çok hareketi olan carilerde kullanım akıcı kalır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Eski işlemler ilk açılışta görünmeyebilir; tarih aralığını genişleterek görebilirsiniz.'),
      ],
    },
    {
      region: 'stats',
      title: t(`${G}.s2.title`, '2. Toplamları okuyun'),
      text: t(`${G}.s2.text`, 'Üstteki Toplam Alacak, Toplam Borç ve Bakiye carinin tüm kayıtlarından hesaplanır. Tarih ve tür filtreleri bu toplamları değiştirmez, yalnız listeyi daraltır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Toplam Alacak: hesaba giriş yönlü hareketlerin toplamı.'),
        t(`${G}.s2.tip2`, 'Toplam Borç: hesaptan çıkış yönlü hareketlerin toplamı.'),
        t(`${G}.s2.tip3`, 'Bakiye = Toplam Alacak − Toplam Borç (carinin tüm kayıtları).'),
        t(`${G}.s2.tip4`, 'Yeni işlem eklendiğinde veya bir işlem değiştiğinde liste ve toplamlar kendiliğinden yenilenir.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s3.title`, '3. Tarih filtresiyle dönemi seçin'),
      text: t(`${G}.s3.text`, 'Tarih seçtiğinizde yalnız o aralıktaki işlemler listelenir. Dönem daraldıkça liste hızlanır, genişledikçe daha çok geçmiş kayıt görünür. Üstteki toplamlar değişmez.'),
      tips: [
        t(`${G}.s3.tip1`, '1) Üstteki "Başlangıç Tarihi" ve "Bitiş Tarihi" alanlarını bulun (telefonda önce "Filtreler"e basın).'),
        t(`${G}.s3.tip2`, '2) İstediğiniz aralığı seçin: son 6 ay, son 1 yıl veya özel bir aralık.'),
        t(`${G}.s3.tip3`, '3) Sistem o aralıktaki işlemleri kendisi getirir.'),
        t(`${G}.s3.tip4`, '4) Filtreyi kaldırmak için "Temizle"ye basın (varsayılan 1 aya döner).'),
        t(`${G}.s3.tip5`, '5) Daha net sonuç için tarihi İşlem Türü filtresiyle birlikte kullanın.'),
        t(`${G}.s3.tip6`, 'Başlangıç tarihi boşsa ilk işlemden, bitiş tarihi boşsa bugüne kadar alınır.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s4.title`, '4. Örnek: bir yılın hareketleri'),
      text: t(`${G}.s4.text`, '"Bu carinin 2024 yılındaki tüm hareketlerini görmek istiyorum": Başlangıç Tarihi 01.01.2024, Bitiş Tarihi 31.12.2024 seçin. Yalnız 2024 işlemleri listelenir; üstteki toplamlar carinin tüm kayıtlarına göre kalır.'),
      tips: [
        t(`${G}.s4.tip1`, 'İşlem Türü ve Şube filtreleri de aynı satırdadır; filtre varken bulunan sonuç sayısı yanında görünür.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Hareketleri sekmelerle ayırın'),
      text: t(`${G}.s5.text`, 'Tüm İşlemler, Alacaklar, Borçlar ve Tahsilatlar sekmeleri listeyi türe göre ayırır (telefonda "Görünüm Seç" listesi). Satırdaki ⋮ düğmesiyle Ayrıntılar\'ı açabilir veya işlemi silebilirsiniz; faturalarda Görüntüle seçeneği de vardır.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s6.title`, '6. Logları görün, Excel\'e aktarın'),
      text: t(`${G}.s6.text`, '"Loglar" hareketlerde yapılan önemli değişikliklerin geçmişini açar. "Excel İndir" ekranda filtrelenmiş hareketleri dosyaya aktarır. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
